const $ = window.jQuery;

function StickyHeader() {
	const scrollPosition = window.scrollY;

	// convert previus part to vanilla js
	const header = document.getElementById('header');
	const headerFixer = header.querySelector('[data-header-fixer]');
	const adminBar = document.getElementById('wpadminbar');
	const body = document.body;

	const headerHeight = header.offsetHeight;
	// get nav outer height

	const nav = header.querySelector('[data-main-nav]');
	const navHeight = nav.offsetHeight;
	//const topNavHeight = header.querySelector('.top-nav').offsetHeight;
	const topNav = header.querySelector('[data-top-nav]');
	const topNavHeight = topNav.offsetHeight;

	// get header by data attribute data-main-nav

	let offset = +topNavHeight - 1;

	if (adminBar) {
		const adminBarHeight = adminBar.offsetHeight;
		offset = +adminBarHeight + +topNavHeight - 1;
	}

	if (scrollPosition >= offset) {
		if (!body.classList.contains('fixed-header')) {
			document.body.classList.add('fixed-header');
			header.classList.add('state--scrolled');
			headerFixer.style.display = 'block';
			topNav.style.opacity = '0';
		}
	} else {
		if (body.classList.contains('fixed-header')) {
			document.body.classList.remove('fixed-header');
			header.classList.remove('state--scrolled');
			headerFixer.style.display = 'none';
			topNav.style.opacity = '1';
		}
	}
}
export default StickyHeader;
